import React from 'react';
import styled from 'styled-components';
import SectionHeader from 'components/text/SectionHeader';
import Body from 'components/text/Body';
import Title from 'components/text/Title';
import Headline from 'components/text/Headline';
import Button from 'components/common/Button';
import Vimeo from '@u-wave/react-vimeo';

const Container = styled.div`
  position: fixed;
  right: 0;
  left: 0;
  top: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.75);
  z-index: 1000;
  align-items: center;
  justify-content: center;
  display: flex;
  @media only screen and (max-width: 400px) {
    display: none;
  }
`;

const VideoContainer = styled.div`
  border: 1px solid #efefef;

  iframe {
    max-width: 100% !important;
  }

  .ant-btn {
    z-index: 1000;
  }
`;

const ContentContainer = styled.div`
  max-width: 100%;
  background: #fff;
  padding: ${p => p.theme.padding}px;
  border-radius: 4px;
  width: 700px;
  border-top: 7px solid ${p => p.theme.color.primary};
`;

const HeaderContainer = styled.div`
  height: 220px;
  width: 75%;
`;
const ButtonContainer = styled.div`
  height: 65px;
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
`;

const Header = () => (
  <HeaderContainer>
    <Headline style={{ marginBottom: 15, display: 'block' }}>Welcome to Hey Ned!</Headline>
    <Body>
      Hey Ned makes it simple for photographers to send contracts, invoices, questionnaires and more to their clients!{' '}
    </Body>
    <Body>
      {' '}
      We know you're excited to get started but we've made this short video tour for you to show you how to use Hey Ned.
    </Body>
    <Body>
      Please make sure to watch it as it will virtually eliminate the learning curve & get you started faster!
    </Body>
  </HeaderContainer>
);

class OnboardingOverlay extends React.PureComponent {
  markOnboardingAsSeen = () => {
    window.localStorage.setItem('userHasSeenVideo', 'true');
    window.location.reload();
  };

  render() {
    return (
      <Container>
        <ContentContainer>
          <Header />
          <VideoContainer>
            <Vimeo video="294200238" autoplay />
          </VideoContainer>
          <ButtonContainer>
            <Button style={{ margin: 0 }} onClick={this.markOnboardingAsSeen}>
              OK, got it
            </Button>
          </ButtonContainer>
        </ContentContainer>
      </Container>
    );
  }
}

export default OnboardingOverlay;



// WEBPACK FOOTER //
// ./src/components/common/OnboardingOverlay/index.js